import { useTitle } from "react-use";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { NotificationsGrid } from "../components/NotificationsGrid";

export function NotificationsPage() {
  useTitle("Notifications");

  return (
    <>
      <SubHeader>
        <SubHeader.Left>
          <Breadcrumbs>
            <Breadcrumb href={{ to: "/help" }}>Support</Breadcrumb>
            <Breadcrumb>Notifications</Breadcrumb>
          </Breadcrumbs>
        </SubHeader.Left>
      </SubHeader>
      <NotificationsGrid />
      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </>
  );
}
